
namespace RioERP.Masters {
    export class AllowedDevicesColumns {
        static columnsKey = 'Masters.AllowedDevices';
    }
}